import React, { useEffect, useState, useMemo } from "react";
import jsPDF from "jspdf";
// import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import * as XLSX from "xlsx";
import { Closed, Noimage } from "../../../../common/imagePath";
import { Box, Button } from "@mui/material";
import CommonMatrialReactTable from "../../../../components/Datatable/CommonMatrialReactTable";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../../common/Constant";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "/manage-items";
let PERMISSION_EDIT = "/manage-items/:id";
let PERMISSION_DELETE = "delete-items";
let PERMISSION_VIEW = "view-items";
let PERMISSION_MANAGE_DELETED_ITEMS = "/deleted-items";
let PERMISSION_EXCEL_IMPORT = "/import-items";
let PERMISSION_EXCEL_EXPORT = "excel-export-items";
let PERMISSION_CLEANUP_OLD_ITEMS = "cleanup-old-items";
let PERMISSION_CUSTOM_FIELD_CONFIGURATION = "/items-custom-fields";
let PERMISSION_SHOW_COST_PRICE = "show-cost-price";

const InventoryPrint = () => {
  const locationData = useLocation();
  let navigate = useNavigate();

  const loginuserid = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  const Location = localStorage.getItem("Location");

  const [searchItemName, setSearchItemName] = useState("");
  const [loading, setLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [tableData, setTableData] = useState([]);

  const [categoriesList, setCategoriesList] = useState([]);
  const [categoryId, setCategoryId] = useState(0);

  console.log(tableData, "tableData");

  const columns = useMemo(
    () => [
      {
        header: "Item ID",
        accessorKey: "ItemId",
        size: 120,
      },
      {
        header: "Name",
        accessorKey: "Name",
        size: 120,
        // filterFn: "contains",
      },
      {
        header: "Category",
        accessorKey: "Category",
        // size: 150,
      },
      // {
      //   header: "Product Id",
      //   accessorKey: "ProductId",
      //   size: 100,
      // },
      {
        header: "Item Number",
        accessorKey: "ItemNumber",
        size: 120,
      },
      // {
      //   header: "Supplier",
      //   accessorKey: "Supplier",
      //   size: 110,
      // },
      {
        header: "Quantity",
        accessorKey: "Quantity",
        size: 80,
      },
    ],
    []
  );

  const handleExcelExport = () => {
    setLoading(true);

    let data = [];

    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `items_details_.xlsx`);
    setLoading(false);
  };

  const renderRowActionMenuItems = ({ row, table }) => [];

  const renderTopToolbarCustomActions = ({ table }) => (
    <Box
      sx={{
        display: "flex",
        gap: "1rem",
        p: "0.5rem",
        flexWrap: "wrap",
      }}
    >
      {console.log(table, "tables")}

      {/* {(table.getIsSomeRowsSelected() ||
                  table.getIsAllRowsSelected()) &&
                  (checkUserPermission("mark-inactive") ? (
                    <Button
                      // size="small"
                      class="btn btn-sm btn-secondary"
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() =>
                        handleDeletePopup(
                          "",
                          "",
                          table.getSelectedRowModel().rows,
                          "multipleRowInactive"
                        )
                      }
                      // startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Mark InActive
                    </Button>
                  ) : (
                    " "
                  ))} */}
      {/* <Button
        size="small"
        onClick={() =>
          setPagination({ ...pagination, pageSize: totalRows })
        }
        variant="contained"
      >
        Get All Data
      </Button> */}
    </Box>
  );

  const handelItemSearch = (value) => {
    if (value != "" || categoryId != 0) {
      //   axios
      //     .get(`${config.itemsBaseUrl}/items/searchitem?searchparam=${value}`, {
      //       headers: {
      //         "Content-Type": "application/json;charset=UTF-8",
      //         Authorization: token,
      //       },
      //     })
      //     .then((response) => {
      //       if (response != "" && response != null) {
      //         const data = response.data.ResponseData;

      //         setSuggestions(data);
      //       }
      //     })
      //     .catch((error) => {});
      // } else {
      //   setSuggestions([]);
      // }
      setLoading(true);
      setSuggestions([]);
      axios
        .get(
          `${config.itemsBaseUrl}/items?filtercolumnsearchtext=&currentorder=desc&ordercolumn=ID&pagenumber=1&pagesize=1000&filtertext=${value}&startdate=&enddate=&categoryid=${categoryId}&tagid=0&supplierid=0&itemType=0&LocationID=${Location}&loginId=${loginuserid}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          setSuggestions(res.data.ResponseData?.list);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      setSuggestions([]);
    }
  };

  useEffect(() => {
    categoriesAPI();
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      handelItemSearch(searchItemName);
    }, 1000);

    // Cleanup function to clear the timeout if the component unmounts
    // or if searchItemName changes before the delay completes
    return () => {
      clearTimeout(handler);
    };
  }, [searchItemName, categoryId]);

  const handalsearch = () => {
    const searchData = suggestions.map((el) => {
      return {
        ItemId: `${el.ID}${el.VariationId > 0 ? "#" + el.VariationId : ""}`,
        ItemVariationId: el.VariationId ? el.VariationId : 0,
        Name: el.Name ? el.Name : "",
        ProductId: el.ProductId ? el.ProductId : "",
        ItemNumber: el.ItemNumber ? el.ItemNumber : "",
        Supplier: el.Supplier ? el.Supplier : "",
        Category: el.Categoryfullpath ? el.Categoryfullpath : "",
        Quantity: el.Quantity ? el.Quantity : 0,
      };
    });
    console.log(searchData, "searchData");
    setTableData(searchData);
    setSuggestions([]);
    setSearchItemName("");
  };

  const categoriesAPI = (CategorieData) => {
    //API
    axios
      .get(`${config.categoriesBaseUrl}/categories?filtertext=${""}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const list = res.data.ResponseData.map((u, i) => {
          return { label: u.Name, value: u.ID };
        });
        setCategoriesList([{ label: "All Category", value: 0 }, ...list]);
      });
  };

  const handleInputClick = (ItemID) => {
    setSuggestions([]);
    setSearchItemName("");
    setCategoryId(0);
    axios
      .get(
        `${config.itemsBaseUrl}/items/inventoryprintbyitem?itemId=${ItemID}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const data = response.data.ResponseData;

        const filterData = data.map((el) => {
          return {
            ItemId: `${el.ItemId}${
              el.ItemVariationId > 0 ? "#" + el.ItemVariationId : ""
            }`,
            ItemVariationId: el.ItemVariationId,
            Name: el.Name,
            ProductId: el.ProductId,
            ItemNumber: el.ItemNumber,
            Supplier: el.Supplier,
            Category: el.Category,
            Quantity: el.Quantity,
          };
        });
        console.log(filterData, "filterData");
        setTableData(filterData);
      })
      .catch((error) => {});
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Inventory: Items</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/items">Items</Link>
                </li>
                <li className="breadcrumb-item active">Inventory Print</li>
              </ul>
            </div>
          </div>
          <div className="row mb-3">
            <div className="d-flex gap-2 align-items-center">
              <div style={{ width: "400px" }}>
                <Select
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  // isClearable={true}
                  // onChange={setselectedCategory}
                  onChange={(e) => {
                    setCategoryId(e.value);
                    setSearchItemName("");
                    setSuggestions([]);
                  }}
                  options={categoriesList}
                  placeholder="Categories"
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  value={categoriesList.find(
                    (option) => option?.value === categoryId
                  )}
                  id="Category"
                  name="Category"
                  className="custom-search-select"
                  style={{ width: "100%" }}
                />
              </div>
              <div>
              <input
                type="search"
                placeholder="Search..."
                // className="form-control-sm w-100 mt-1"
                className="search-btn form-control form-control-sm w-100"
                onChange={(e) => {
                  setSearchItemName(e.target.value);
                }}
                value={searchItemName}
                />
                {suggestions.length > 0 ? (
              <div
                className="dropdown"
                style={{ position: "relative", width: "400px" }}
              >
                <ul
                  className="dropdown-menu  show"
                  style={{
                    width: "100%",
                    maxHeight: "400px",
                    overflowY: "auto",
                  }}
                >
                  {suggestions.map((item, index) => (
                    <li
                      key={index}
                      className={
                        0 === index
                          ? "dropdown-item active p-2"
                          : "dropdown-item p-2"
                      }
                      // className="m-2"
                      onClick={(e) => handleInputClick(item.ID)}
                    >
                      <a
                        key={item.ID}
                        href="#"
                        // className={
                        //   cursor === index
                        //     ? "dropdown-item active"
                        //     : "dropdown-item"
                        // }
                        className="d-flex gap-2"
                        data-name={item.Name.toLowerCase()}
                        // onClick={handleInputClick(item.ItemId,item.ItemName)}
                      >
                        <img
                          src={item.ImageURL ? item.ImageURL : Noimage}
                          alt={item.Name}
                          className="img-thumbnail rounded-circle"
                          style={{
                            maxWidth: "55px",
                            maxHeight: "55px",
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = Noimage;
                          }}
                        />
                        <div className="customer-info ml-2  ">
                          <p className="name">{item.Name}</p>
                          <div>
                            Qty: {Number(item.Quantity).toFixed(2)} |
                            Categories: {item?.Categoryfullpath}
                          </div>
                          {/* Add any other customer details here */}
                        </div>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              ""
            )}
                </div>
              <Button
                // size="small"
                className="btn btn-sm btn-secondary"
                style={{ display: "flex" }}
                color="primary"
                //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                onClick={() => handalsearch()}
                variant="contained"
              >
                Search
              </Button>
              {suggestions?.length > 0 && (
                <i
                  class="fa fa-times-circle fs-3 cursor-pointer"
                  onClick={() => {
                    setSuggestions([]);
                    setSearchItemName("");
                    setCategoryId(0);
                  }}
                ></i>
              )}
            </div>
            
          </div>
          {/* {tableData?.length > 0 && ( */}
          <div className="card">
            <div className="card-body custom-table-css">
              <div
                className="table-responsive"
                // style={{ position: "relative", zIndex: "0" }}
              >
                <CommonMatrialReactTable
                  MainHeading="Sonar POS"
                  ReportHeading="Inventory Print"
                  columns={columns}
                  data={tableData}
                  startdate={""}
                  enddate={""}
                  columnGrouping={[]}
                  columnsVisibility={{}}
                  isItemInventory={true}
                />
              </div>
            </div>
          </div>
          {/* )} */}
        </div>
      </div>
    </>
  );
};

export default InventoryPrint;


